import { useQuery } from "@tanstack/react-query";
import { countDiamonds } from "../api/diamonds";

export default function useDiamondCountQuery(filters) {
    return useQuery({
        queryKey: ["wahchan", "diamond-count", filters],
        queryFn: ({ signal }) => countDiamonds(filters, { signal }),
        enabled: !!filters,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
    });
}
